var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.impressionsChartOptions,"series":_vm.item}})}
var staticRenderFns = []

export { render, staticRenderFns }